<template>
  <v-btn v-if="value" icon small>
    <v-icon small @click="showDialog = true">mdi-gift-outline</v-icon>
    <DialogGifteeDetails
      v-if="showDialog"
      @close="showDialog = false"
      @change="showDialog = $event"
      :show="showDialog"
      :order="theOrder"
    />
  </v-btn>
</template>

<script>
import { Model } from '@vuex-orm/core'
import DialogGifteeDetails from '@/components/DialogGifteeDetails.vue'
export default {
  name: 'AdminCellGiftee',
  components: {
    DialogGifteeDetails,
  },
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      showDialog: false,
    }
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
    tooltipHtml() {
      return {
        content: `<div class="proxima--font">${this.value}</div>`,
        html: true,
      }
    }, // tooltipHtml
    theOrder() {
      return this.Model.find(this.id)
    }, // theOrder
  },
}
</script>
